import qs from "qs";
import { ISupplierInvoiceRecordResponse } from "../interfaces/supplier-invoice-record";
import authBaseAxios from "../utils/api";

export const SupplierInvoiceRecordServices = {
  getAll: (params: any): Promise<ISupplierInvoiceRecordResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`supplier-invoice-records?${queryString}`);
  },
  getDropdownByType: (type: string, params?: any): any => {
    return authBaseAxios.get(`supplier-invoice-records/dropdown-data`, { params: {
      type,
      ...params
    } });
  },
};
